/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Adr_Tempo_BpmInputs */



/**
* | output |
* | --- |
* | "Tempo / BPM" |
*
* @param {Options_Adr_Tempo_BpmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_adr_tempo_bpm = /** @type {((inputs?: Options_Adr_Tempo_BpmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Adr_Tempo_BpmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tempo / BPM")
	if (locale === "de") return /** @type {LocalizedString} */ ("Tempo / BPM")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tempo / BPM")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Темп / BPM")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tempo / BPM")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("速度/BPM")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テンポ/BPM")
	if (locale === "hi") return /** @type {LocalizedString} */ ("गति / बीपीएम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tempo / BPM")
	return /** @type {LocalizedString} */ ("Tempo / BPM")
});